<template>
  <div v-if="options!==null && options!==undefined">
    <pbas-data-table
      v-if="provider"
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="membership-history"
      :identifier="'membership_table'+selectedPlan.Id"
      @error="error = $event"
      :show-select="false"
    ></pbas-data-table>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="loading" scrollable max-width="100px" persistent>
      <v-container fluid grid-list-md>
        <v-layout row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import getMembershipHistoryHeaders from "@/headers/MembershipHistory";
import ErrorHandler from "@/components/ErrorHandler";

export default {
  props: ["memberId", "hasClasses"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      loading: false,
      provider: null,
      error: null,
    };
  },
  methods: {
    async loadData() {
      this.provider = null;
      const headers = getMembershipHistoryHeaders(this.options, this.selectedPlan.PlanType, this.hasClasses);
      if (this.memberId) {
        const url = `/plans/${this.selectedPlan.Id}/members/${
          this.memberId
        }/membership-history`;
        this.provider = new ODataProvider(
          this.$axiosHttp,
          url,
          headers
        );
      }
    },
  },
  computed: {
    ...mapGetters("plansMembers", ['options', "planIdentity"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["role"]),
  },
  watch: {
    memberId: {
      immediate: true,
      handler: function() {
        this.loadData();
      },
    },
  },
  // mounted() {
  //   console.log("id", this.memberId);
  //   console.log("employer", this.employerId);
  // },
};
</script>
